import request from '@/utils/request'

export function signupIMSTijarah(username, email, password) {
  return request({
    url: '/auth/local/register',
    method: 'post',
    data: {
      username: username,
      email: email,
      password: password,
      feature: 'imstijarah',
      role: 'Distributor'
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/signup.js